/**
 * @generated SignedSource<<01fc5a602ea0ef12c6b9d13266778f55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Cleanliness = "BAD" | "GREAT" | "MEDIUM" | "%future added value";
export type CustomerSatisfaction = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type JobTypes = "INSTALLATION" | "INSTALLATION_FOLLOW_UP" | "SAMPLE_EVENT" | "SITE_VISIT" | "%future added value";
export type StaffEnthusiasm = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Status = "COMPLETED" | "IN_PROCESS" | "ON_HOLD" | "PENDING" | "%future added value";
export type StatusOfSanitizer = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type TrafficRate = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type EditJobModal_getLogJobQuery$variables = {
  id: string;
};
export type EditJobModal_getLogJobQuery$data = {
  readonly getLogJob: {
    readonly additionalComments: string | null;
    readonly cleanliness: Cleanliness | null;
    readonly closingDateAndTime: string | null;
    readonly customerSatisfaction: CustomerSatisfaction | null;
    readonly dateAndTime: string;
    readonly id: string;
    readonly jobType: JobTypes;
    readonly locationId: string;
    readonly machineName: string | null;
    readonly machineSerialNumber: string | null;
    readonly marketingMaterials: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly sanitizerStatus: StatusOfSanitizer | null;
    readonly staffEnthusiasm: StaffEnthusiasm | null;
    readonly status: Status;
    readonly trafficRate: TrafficRate | null;
    readonly travelTime: number | null;
    readonly uploadImagesOrVideos: ReadonlyArray<{
      readonly type: string | null;
      readonly url: string | null;
    }> | null;
    readonly uuid: string | null;
  };
};
export type EditJobModal_getLogJobQuery = {
  response: EditJobModal_getLogJobQuery$data;
  variables: EditJobModal_getLogJobQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "LogJobsObjectType",
    "kind": "LinkedField",
    "name": "getLogJob",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateAndTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaDto",
        "kind": "LinkedField",
        "name": "uploadImagesOrVideos",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketingMaterialsObjectType",
        "kind": "LinkedField",
        "name": "marketingMaterials",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sanitizerStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "machineSerialNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "machineName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalComments",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerSatisfaction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cleanliness",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "trafficRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "staffEnthusiasm",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "closingDateAndTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "travelTime",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditJobModal_getLogJobQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditJobModal_getLogJobQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8b62ca22c1dc5928d9e2fdedc8b5cf47",
    "id": null,
    "metadata": {},
    "name": "EditJobModal_getLogJobQuery",
    "operationKind": "query",
    "text": "query EditJobModal_getLogJobQuery(\n  $id: String!\n) {\n  getLogJob(id: $id) {\n    id\n    uuid\n    jobType\n    locationId\n    dateAndTime\n    uploadImagesOrVideos {\n      url\n      type\n    }\n    marketingMaterials {\n      id\n      name\n    }\n    sanitizerStatus\n    machineSerialNumber\n    machineName\n    additionalComments\n    customerSatisfaction\n    cleanliness\n    trafficRate\n    staffEnthusiasm\n    status\n    closingDateAndTime\n    travelTime\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8ccc1a35bd7ccb63acd8940cf5530a3";

export default node;
